// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: var(--text-primary, #f8fafc);
  font-family: 'Inter', sans-serif;
  overflow: hidden;
}

.settings-container {
  display: flex;
  width: 100%;
  max-width: 1200px;
  height: 86vh;
  max-height: 840px;
  min-height: 560px;
  margin: auto;
  background: var(--bg-primary, #0f172a);
  border-radius: 24px;
  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));
  box-shadow: 
    0 25px 60px -15px rgba(0, 0, 0, 0.8),
    0 0 0 1px rgba(255, 255, 255, 0.06),
    0 10px 30px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  position: relative;
}

.settings-sidebar {
  width: 270px;
  background: var(--bg-secondary, rgba(15, 23, 42, 0.85));
  border-right: 1px solid var(--glass-border, rgba(255, 255, 255, 0.06));
  padding: 32px 14px 24px 24px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.settings-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.nav-label {
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted, #64748b);
  padding: 8px 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  color: var(--text-secondary, #94a3b8);
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.18s ease;
  text-align: left;
  width: 100%;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-primary, #f8fafc);
  transform: translateX(2px);
}

.nav-item.active {
  background: var(--brand-primary, #991b1b);
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 4px 14px rgba(153, 27, 27, 0.35);
}

.logout-btn {
  color: #ef4444;
  margin-top: 10px;
}

.logout-btn:hover {
  background: rgba(239, 68, 68, 0.12);
  color: #f87171;
}

.settings-main {
  flex: 1;
  background: var(--bg-primary, #0f172a);
  padding: 36px 48px;
  position: relative;
  overflow-y: auto;
}

/* Custom Scrollbar for Settings Main Content */
.settings-main::-webkit-scrollbar {
  width: 8px;
}

.settings-main::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

.settings-main::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));
  border-radius: 4px;
}

.settings-main::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary);
}

.settings-content {
  max-width: 780px;
}

.settings-section h2 {
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
}

.section-desc {
  color: var(--text-secondary, #94a3b8);
  font-size: 14px;
  margin-bottom: 20px;
}

/* User Profile Preview Enhanced */
.user-profile-preview-container {
  margin-bottom: 32px;
}

.user-profile-preview {
  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.02));
  border-radius: var(--radius-lg, 18px);
  overflow: hidden;
  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.preview-banner {
  height: 120px;
  background: var(--brand-primary);
  transition: all var(--transition-normal);
}

.user-profile-preview .preview-info {
  padding: 16px 24px 24px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  position: relative;
}

.preview-avatar {
  width: 90px;
  height: 90px;
  border-radius: var(--radius-full);
  background: var(--bg-secondary);
  margin-top: -55px;
  border: 6px solid var(--bg-primary);
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-md);
  flex-shrink: 0;
}

.user-bio-preview {
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.5;
  margin-top: 8px !important;
  max-width: 400px;
}

.edit-profile-btn {
  margin-left: auto;
  background: var(--brand-primary);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: var(--radius-md);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.edit-profile-btn:hover {
  transform: translateY(-2px);
  filter: brightness(1.1);
}

/* User Account Settings Fields */
.settings-field-group {
  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.02));
  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.06));
  border-radius: 16px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.settings-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-radius: var(--radius-sm);
  transition: background-color var(--transition-fast);
}

.settings-field:hover {
  background-color: rgba(255, 255, 255, 0.02);
}

.settings-field:not(:last-child) {
  border-bottom: 1px solid var(--glass-border);
}

.field-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.field-value {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.field-edit-btn {
  background-color: var(--bg-modifier-hover);
  border: 1px solid var(--glass-border);
  color: var(--text-primary);
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.field-edit-btn:hover {
  background-color: var(--brand-primary);
  border-color: var(--brand-primary);
  color: white;
  transform: translateY(-1px);
}

/* Banner Type Tabs */
.banner-type-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.banner-type-tabs .tab {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--glass-border);
  color: var(--text-secondary);
  padding: 6px 12px;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.banner-type-tabs .tab.active {
  background: var(--brand-primary);
  border-color: var(--brand-primary);
  color: white;
}

/* Profile Editor View */
.profile-editor-view {
  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.02));
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-height: 520px;
  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

.editor-header {
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--glass-border);
  background: rgba(255, 255, 255, 0.02);
}

.editor-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.editor-layout {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.editor-controls {
  flex: 1;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow-y: auto;
}

/* Custom Scrollbar for Editor Controls */
.editor-controls::-webkit-scrollbar {
  width: 8px;
}

.editor-controls::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

.editor-controls::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));
  border-radius: 4px;
}

.editor-controls::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary);
}

.editor-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.editor-section label {
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted);
  letter-spacing: 0.1em;
}

.avatar-actions, .banner-actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all var(--transition-fast);
}

.action-btn.primary {
  background: var(--brand-primary);
  color: white;
}

.action-btn.secondary {
  background: transparent;
  border-color: var(--glass-border);
  color: var(--text-primary);
}

.action-btn:hover {
  filter: brightness(1.1);
}

.color-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
  gap: 8px;
  margin-top: 8px;
}

.color-item {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  transition: all var(--transition-fast);
}

.color-item:hover {
  transform: scale(1.1);
}

.color-item.active {
  border-color: white;
}

.editor-section textarea {
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  padding: 12px;
  color: var(--text-primary);
  font-family: inherit;
  font-size: 15px;
  resize: none;
  height: 100px;
  outline: none;
}

.editor-input {
  width: 100%;
  background: rgba(15, 23, 42, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 10px 14px;
  color: white;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.editor-input:focus {
  border-color: var(--brand-primary);
}

.preview-username-tag {
  font-size: 13px;
  color: var(--text-muted);
  margin-top: -4px;
  margin-bottom: 12px;
}

.cropper-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.9);
  backdrop-filter: blur(10px);
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.cropper-card {
  width: 100%;
  max-width: 500px;
  background: var(--bg-secondary);
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.cropper-header {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--glass-border);
}

.cropper-header h3 {
  margin: 0;
  font-size: 18px;
}

.cropper-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.cropper-container {
  position: relative;
  width: 100%;
  height: 350px;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

.cropper-controls {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px 5px;
}

.zoom-range {
  flex: 1;
  height: 4px;
  background: var(--bg-modifier-hover);
  border-radius: 2px;
  appearance: none;
  outline: none;
}

.zoom-range::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.cropper-footer {
  padding: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: rgba(0,0,0,0.2);
}

/* Ensure images cover their container */
.preview-avatar img,
.user-avatar img,
.avatar-frame img,
.avatar-main img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.char-count {
  align-self: flex-end;
  font-size: 12px;
  color: var(--text-muted);
}

.editor-preview {
  width: 360px;
  padding: 32px;
  background: rgba(0, 0, 0, 0.2);
  border-left: 1px solid var(--glass-border);
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-shrink: 0;
}

.preview-card {
  border-radius: 12px;
  overflow: hidden;
  background: var(--bg-secondary);
  border: 1px solid var(--glass-border);
  box-shadow: var(--shadow-xl);
  width: 100%;
}

.preview-card .preview-banner {
  height: 100px;
}

.preview-content {
  padding: 16px;
}

.preview-avatar-wrapper {
  margin-top: -45px;
  margin-bottom: 12px;
}

.preview-avatar-wrapper .preview-avatar {
  width: 70px;
  height: 70px;
  margin-top: 0;
  border-width: 4px;
}

.preview-info h3 {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.preview-info .tag {
  color: var(--text-muted);
  font-weight: 400;
  font-size: 14px;
}

.preview-bio {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.4;
  margin-top: 8px;
  white-space: pre-wrap;
}

.editor-footer {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  border-top: 1px solid var(--glass-border);
  background: rgba(0, 0, 0, 0.1);
}

.save-btn {
  background: var(--brand-primary);
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: var(--radius-md);
  font-weight: 700;
  cursor: pointer;
}

.cancel-btn {
  background: transparent;
  color: var(--text-secondary);
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.cancel-btn:hover {
  color: var(--text-primary);
}

.field-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.bio-value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}

.close-btn {
  background: none;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  padding: 8px;
  border-radius: var(--radius-full);
  transition: all var(--transition-fast);
}

.close-btn:hover {
  background: var(--bg-modifier-hover);
  color: var(--text-primary);
}

/* Connections */
.connections-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
}

.connection-card {
  background: #0f172a;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.connection-card.spotify {
  border-left: 4px solid #1db954;
}

.conn-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.conn-status {
  font-size: 11px;
  font-weight: 800;
  background: rgba(29, 185, 84, 0.2);
  color: #1db954;
  padding: 2px 8px;
  border-radius: 4px;
}

.conn-status.disconnected {
  background: rgba(100, 116, 139, 0.2);
  color: #64748b;
}

.conn-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 13px;
}

.toggle-switch {
  width: 36px;
  height: 20px;
  background: #334155;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
}

.toggle-switch::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  transition: 0.2s;
}

.toggle-switch.active {
  background: #1db954;
}

.toggle-switch.active::after {
  left: 18px;
}

/* Close Area */
.settings-close-area {
  position: absolute;
  top: 24px;
  right: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  z-index: 20;
}

.close-circle-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.12));
  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.05));
  color: var(--text-secondary, #94a3b8);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.close-circle-btn:hover {
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.4);
  color: #ef4444;
  transform: rotate(90deg) scale(1.05);
}

.esc-text {
  font-size: 10px;
  font-weight: 800;
  color: var(--text-muted, #64748b);
  letter-spacing: 0.05em;
}

/* Theme Configuration Cards CSS */
.themes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
  margin-top: 24px;
}

.theme-card {
  background: var(--bg-primary);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: all var(--transition-normal);
  box-shadow: var(--shadow-sm);
}

.theme-card:hover {
  transform: translateY(-4px);
  border-color: var(--brand-primary);
  box-shadow: var(--shadow-md);
}

.theme-card.active {
  border-color: var(--brand-primary);
  box-shadow: 0 0 12px rgba(153, 27, 27, 0.2);
  background: var(--bg-modifier-selected);
}

/* Preview area inside card */
.theme-card-preview {
  height: 90px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--glass-border);
}

.color-strip {
  position: absolute;
  height: 12px;
  width: 60px;
  border-radius: 4px;
}

.brand-strip {
  top: 24px;
  left: 20px;
}

.text-strip {
  top: 48px;
  left: 20px;
  width: 100px;
}

.theme-active-checkmark {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  border-radius: var(--radius-full);
  background: var(--brand-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-sm);
}

.theme-card-info {
  padding: 16px;
}

.theme-card-info h4 {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 6px;
  color: var(--text-primary);
}

.theme-card-info p {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.4;
}

/* Platform Connection Highlights */
.connection-card.spotify { border-left: 4px solid #1db954; }
.connection-card.steam { border-left: 4px solid #66c0f4; }
.connection-card.epic { border-left: 4px solid #ffffff; }
.connection-card.flexable { border-left: 4px solid #8b5cf6; }

.conn-disconnect-btn {
  background: transparent;
  border: 1px solid #ef4444;
  color: #ef4444;
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 15px;
  transition: all var(--transition-fast);
  text-align: center;
}

.conn-disconnect-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  transform: translateY(-1px);
}

/* Modals */
.connection-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.8);
  backdrop-filter: blur(12px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.connection-modal {
  width: 100%;
  max-width: 440px;
  padding: 24px;
}

/* Settings Blocks & Fields */
.settings-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.settings-block h3 {
  font-size: 12px;
  font-weight: 800;
  color: var(--text-muted);
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.block-desc {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.4;
}

/* Radio Cards (Privacy settings) */
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.radio-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.01);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.radio-card:hover {
  background: var(--bg-modifier-hover);
}

.radio-card.active {
  background: var(--bg-modifier-selected);
  border-color: var(--brand-primary);
}

.radio-card input[type="radio"] {
  accent-color: var(--brand-primary);
  width: 18px;
  height: 18px;
  margin-top: 2px;
  cursor: pointer;
}

.radio-label-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.radio-label-info strong {
  font-size: 14px;
  color: var(--text-primary);
}

.radio-label-info span {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.4;
}

/* Checkbox inputs */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 6px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  transition: color var(--transition-fast);
}

.checkbox-item:hover {
  color: var(--text-primary);
}

.checkbox-item input[type="checkbox"] {
  accent-color: var(--brand-primary);
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Block list styling */
.blocklist-input-wrapper {
  display: flex;
  gap: 12px;
  margin-top: 6px;
}

.block-input {
  flex: 1;
}

.blocked-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-md);
  padding: 12px;
  background: rgba(0,0,0,0.1);
}

/* Custom Scrollbar for Blocked List */
.blocked-list::-webkit-scrollbar {
  width: 6px;
}

.blocked-list::-webkit-scrollbar-track {
  background: transparent;
}

.blocked-list::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));
  border-radius: 3px;
}

.blocked-list::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary);
}

.blocked-user-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  background: rgba(255,255,255,0.01);
  border: 1px solid var(--glass-border);
}

.blocked-user-row span {
  font-size: 14px;
  font-weight: 600;
}

.unblock-btn {
  background: none;
  border: 1px solid var(--glass-border);
  color: var(--text-secondary);
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.unblock-btn:hover {
  border-color: #ef4444;
  color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}

.no-blocked-users {
  font-size: 13px;
  color: var(--text-muted);
  text-align: center;
  padding: 20px 0;
}

/* Voice & Video inputs */
.device-selects-row {
  display: flex;
  gap: 20px;
  margin-top: 6px;
}

.select-field {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.select-field label {
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted);
}

.device-dropdown {
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  transition: border-color var(--transition-fast);
}

.device-dropdown:focus {
  border-color: var(--brand-primary);
}

/* Range sliders (Voice level control) */
.volume-sliders-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 6px;
}

.volume-slider-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 800;
  color: var(--text-muted);
}

.voice-range-slider {
  appearance: none;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: var(--input-bg);
  outline: none;
}

.voice-range-slider::-webkit-slider-runnable-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
}

.voice-range-slider::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: var(--radius-full);
  background: white;
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  margin-top: -6px;
  transition: all var(--transition-fast);
}

.voice-range-slider::-webkit-slider-thumb:hover {
  background: var(--brand-light);
  transform: scale(1.1);
}

/* Mic test visualization */
.mic-test-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
}

.mic-test-btn.active-test {
  background: var(--success);
  box-shadow: 0 0 12px rgba(16, 185, 129, 0.3);
}

.mic-visualizer-track {
  flex: 1;
  height: 10px;
  background: var(--input-bg);
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  border: 1px solid var(--glass-border);
}

.mic-visualizer-bar {
  height: 100%;
  width: 0%;
  border-radius: 5px;
  transition: width 0.1s ease-out;
}

/* Toggle Switches */
.toggle-list {
  display: flex;
  flex-direction: column;
}

.toggle-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
}

.toggle-label-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.toggle-label-info strong {
  font-size: 14px;
  color: var(--text-primary);
}

.toggle-label-info p {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.4;
}

@media (max-width: 768px) {
  .device-selects-row {
    flex-direction: column;
    gap: 12px;
  }
}

/* Custom Select for Settings */
.custom-select-wrapper {
  position: relative;
  width: 100%;
}

.custom-select-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background-color: var(--input-bg, #1e1f22);
  border: 1px solid var(--input-border, #1e1f22);
  border-radius: 4px;
  color: var(--text-primary, #dbdee1);
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  font-size: 14px;
}

.custom-select-header:hover {
  border-color: #000000;
}

.custom-select-header.open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.custom-select-header-content {
  display: flex;
  flex-direction: column;
}

.custom-select-main-label {
  font-weight: 500;
}

.custom-select-sub-label {
  font-size: 12px;
  color: var(--text-muted, #949ba4);
  margin-top: 2px;
}

.custom-select-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: var(--input-bg, #2b2d31);
  border: 1px solid #1e1f22;
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 100;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.24);
  padding: 4px 0;
}

.custom-select-menu::-webkit-scrollbar {
  width: 8px;
}
.custom-select-menu::-webkit-scrollbar-thumb {
  background: #1a1b1e;
  border-radius: 4px;
}

.custom-select-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  margin: 0 4px;
  border-radius: 3px;
  cursor: pointer;
  color: var(--text-primary, #dbdee1);
  font-size: 14px;
}

.custom-select-item:hover {
  background-color: rgba(79, 84, 92, 0.32);
}

.custom-select-item.selected {
  background-color: rgba(79, 84, 92, 0.6);
}

.custom-select-item-content {
  display: flex;
  flex-direction: column;
}

.custom-select-check {
  color: var(--brand-primary, #5865F2);
  display: flex;
  align-items: center;
}

/* ========================================================
   DISCORD-STYLE SPOTIFY CONNECTED CARD (ACCURATE TO UI)
   ======================================================== */
.spotify-settings-block {
  margin-top: 10px;
}

.settings-block-title {
  font-size: 12px;
  font-weight: 800;
  color: var(--text-muted, #64748b);
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.discord-connected-account-card {
  background: #2b2d31;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 20px 24px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
  transition: all 0.2s ease;
}

.discord-connected-account-card:hover {
  border-color: rgba(29, 185, 84, 0.3);
}

.dca-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dca-account-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dca-icon-circle.spotify {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(29, 185, 84, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1db954;
  flex-shrink: 0;
}

.dca-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.dca-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dca-name {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}

.dca-premium-badge {
  font-size: 9px;
  font-weight: 800;
  background: rgba(29, 185, 84, 0.2);
  color: #1db954;
  padding: 2px 6px;
  border-radius: 4px;
  letter-spacing: 0.05em;
}

.dca-platform {
  font-size: 12px;
  color: #94a3b8;
}

.dca-disconnect-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.dca-disconnect-btn:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.12);
}

.dca-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 18px 0 14px 0;
}

.dca-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
}

.dca-toggle-label {
  font-size: 14px;
  font-weight: 500;
  color: #f1f5f9;
}

/* Accurate iOS/Discord style toggle switch */
.dca-toggle-switch {
  width: 44px;
  height: 24px;
  background: #475569;
  border-radius: 14px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dca-toggle-switch.active {
  background: #5865f2 !important; /* Exact blue/purple matching screenshot */
}

.dca-toggle-slider {
  width: 18px;
  height: 18px;
  background: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.dca-toggle-switch.active .dca-toggle-slider {
  transform: translateX(20px);
}

/* Live Player Card inside Settings */
.dca-live-player {
  margin-top: 16px;
  padding: 12px 14px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(29, 185, 84, 0.25);
}

.dca-live-art {
  width: 46px;
  height: 46px;
  border-radius: 8px;
  object-fit: cover;
  flex-shrink: 0;
}

.dca-live-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.dca-live-badge {
  font-size: 10px;
  font-weight: 800;
  color: #1db954;
  display: flex;
  align-items: center;
  gap: 6px;
}

.live-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1db954;
  animation: pulse 1.5s infinite;
}

.dca-live-song {
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dca-live-artist {
  font-size: 11px;
  color: #94a3b8;
}

/* Not connected banner */
.spotify-connect-banner {
  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.03));
  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));
  border-radius: 14px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.scb-left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 260px;
}

.scb-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(29, 185, 84, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.scb-title {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}

.scb-desc {
  margin: 0;
  font-size: 12px;
  color: var(--text-secondary, #94a3b8);
  line-height: 1.4;
  max-width: 440px;
}

.spotify-btn-action {
  background: #1db954;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(29, 185, 84, 0.35);
}

.spotify-btn-action:hover {
  background: #1ed760;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(29, 185, 84, 0.45);
}

.spotify-oauth-btn {
  width: 100%;
  background: #1db954;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 12px;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(29, 185, 84, 0.3);
}

.spotify-oauth-btn:hover {
  background: #1ed760;
  transform: translateY(-1px);
}

/* SoundCloud Connect Banner & Controls */
.soundcloud-connect-banner {
  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.03));
  border: 1px solid rgba(255, 85, 0, 0.2);
  border-radius: 14px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.scb-icon.soundcloud-icon {
  background: rgba(255, 85, 0, 0.15);
}

.soundcloud-btn-action {
  background: #ff5500;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(255, 85, 0, 0.35);
}

.soundcloud-btn-action:hover {
  background: #ff6a1f;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(255, 85, 0, 0.45);
}

/* Connection Modal Styling */
.connection-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.connection-modal.meci-modal {
  background: #111827;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  width: 100%;
  max-width: 440px;
  padding: 28px 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
}

.connection-modal .modal-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
}

.connection-modal .modal-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.connection-modal .modal-header p {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
  line-height: 1.5;
}

.connection-modal .editor-input {
  background: #1e293b;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 12px 14px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
}

.connection-modal .editor-input:focus {
  border-color: #3b82f6;
}

.connection-modal .cancel-btn {
  background: transparent;
  color: #94a3b8;
  border: none;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: color 0.2s;
}

.connection-modal .cancel-btn:hover {
  color: #ffffff;
}

.connection-modal .save-btn {
  background: #10b981;
  color: #ffffff;
  border: none;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.connection-modal .save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Settings Camera Effects & Mirroring Controls ── */
.camera-controls-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.camera-control-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 10px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.camera-control-card:hover {
  background: rgba(255, 255, 255, 0.07);
  border-color: rgba(255, 255, 255, 0.18);
  transform: translateY(-2px);
}

.camera-control-card.active {
  background: rgba(88, 101, 242, 0.18);
  border-color: #5865f2;
  box-shadow: 0 0 14px rgba(88, 101, 242, 0.3);
}

.camera-control-card-icon {
  font-size: 20px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.camera-control-card-label {
  font-size: 11px;
  font-weight: 700;
  color: #f1f5f9;
}

.camera-control-card-desc {
  font-size: 10px;
  color: #94a3b8;
  margin-top: 2px;
}


`, "",{"version":3,"sources":["webpack://./src/components/Settings/Settings.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;EACnB,gEAAgE;EAChE;;;kCAGgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uDAAuD;EACvD,sEAAsE;EACtE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,qCAAqC;EACrC,gBAAgB;EAChB,gEAAgE;EAChE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,+BAA+B;EAC/B,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,+DAA+D;EAC/D,gEAAgE;EAChE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,0BAA0B;EAC1B,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,4BAA4B;EAC5B,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,+DAA+D;EAC/D,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gEAAgE;EAChE,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;;;;EAIE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gEAAgE;EAChE,+DAA+D;EAC/D,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC,2BAA2B,8BAA8B,EAAE;AAC3D,yBAAyB,8BAA8B,EAAE;AACzD,wBAAwB,8BAA8B,EAAE;AACxD,4BAA4B,8BAA8B,EAAE;;AAE5D;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,kCAAkC;AACpC;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,8CAA8C;EAC9C,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;;AAEA;;6DAE6D;AAC7D;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B,EAAE,0CAA0C;AAC5E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wDAAwD;EACxD,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,+DAA+D;EAC/D,gEAAgE;EAChE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE,+DAA+D;EAC/D,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB","sourcesContent":[".settings-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.72);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  color: var(--text-primary, #f8fafc);\n  font-family: 'Inter', sans-serif;\n  overflow: hidden;\n}\n\n.settings-container {\n  display: flex;\n  width: 100%;\n  max-width: 1200px;\n  height: 86vh;\n  max-height: 840px;\n  min-height: 560px;\n  margin: auto;\n  background: var(--bg-primary, #0f172a);\n  border-radius: 24px;\n  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));\n  box-shadow: \n    0 25px 60px -15px rgba(0, 0, 0, 0.8),\n    0 0 0 1px rgba(255, 255, 255, 0.06),\n    0 10px 30px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  position: relative;\n}\n\n.settings-sidebar {\n  width: 270px;\n  background: var(--bg-secondary, rgba(15, 23, 42, 0.85));\n  border-right: 1px solid var(--glass-border, rgba(255, 255, 255, 0.06));\n  padding: 32px 14px 24px 24px;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n\n.settings-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.nav-label {\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted, #64748b);\n  padding: 8px 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  color: var(--text-secondary, #94a3b8);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.18s ease;\n  text-align: left;\n  width: 100%;\n}\n\n.nav-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--text-primary, #f8fafc);\n  transform: translateX(2px);\n}\n\n.nav-item.active {\n  background: var(--brand-primary, #991b1b);\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 4px 14px rgba(153, 27, 27, 0.35);\n}\n\n.logout-btn {\n  color: #ef4444;\n  margin-top: 10px;\n}\n\n.logout-btn:hover {\n  background: rgba(239, 68, 68, 0.12);\n  color: #f87171;\n}\n\n.settings-main {\n  flex: 1;\n  background: var(--bg-primary, #0f172a);\n  padding: 36px 48px;\n  position: relative;\n  overflow-y: auto;\n}\n\n/* Custom Scrollbar for Settings Main Content */\n.settings-main::-webkit-scrollbar {\n  width: 8px;\n}\n\n.settings-main::-webkit-scrollbar-track {\n  background: var(--bg-secondary);\n}\n\n.settings-main::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));\n  border-radius: 4px;\n}\n\n.settings-main::-webkit-scrollbar-thumb:hover {\n  background: var(--brand-primary);\n}\n\n.settings-content {\n  max-width: 780px;\n}\n\n.settings-section h2 {\n  font-size: 22px;\n  font-weight: 800;\n  margin-bottom: 20px;\n  letter-spacing: -0.02em;\n}\n\n.section-desc {\n  color: var(--text-secondary, #94a3b8);\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n/* User Profile Preview Enhanced */\n.user-profile-preview-container {\n  margin-bottom: 32px;\n}\n\n.user-profile-preview {\n  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.02));\n  border-radius: var(--radius-lg, 18px);\n  overflow: hidden;\n  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n}\n\n.preview-banner {\n  height: 120px;\n  background: var(--brand-primary);\n  transition: all var(--transition-normal);\n}\n\n.user-profile-preview .preview-info {\n  padding: 16px 24px 24px;\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  position: relative;\n}\n\n.preview-avatar {\n  width: 90px;\n  height: 90px;\n  border-radius: var(--radius-full);\n  background: var(--bg-secondary);\n  margin-top: -55px;\n  border: 6px solid var(--bg-primary);\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--shadow-md);\n  flex-shrink: 0;\n}\n\n.user-bio-preview {\n  color: var(--text-secondary);\n  font-size: 14px;\n  line-height: 1.5;\n  margin-top: 8px !important;\n  max-width: 400px;\n}\n\n.edit-profile-btn {\n  margin-left: auto;\n  background: var(--brand-primary);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: var(--radius-md);\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.edit-profile-btn:hover {\n  transform: translateY(-2px);\n  filter: brightness(1.1);\n}\n\n/* User Account Settings Fields */\n.settings-field-group {\n  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.02));\n  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.06));\n  border-radius: 16px;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.settings-field {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  border-radius: var(--radius-sm);\n  transition: background-color var(--transition-fast);\n}\n\n.settings-field:hover {\n  background-color: rgba(255, 255, 255, 0.02);\n}\n\n.settings-field:not(:last-child) {\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.field-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.field-label {\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.field-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.field-edit-btn {\n  background-color: var(--bg-modifier-hover);\n  border: 1px solid var(--glass-border);\n  color: var(--text-primary);\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.field-edit-btn:hover {\n  background-color: var(--brand-primary);\n  border-color: var(--brand-primary);\n  color: white;\n  transform: translateY(-1px);\n}\n\n/* Banner Type Tabs */\n.banner-type-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.banner-type-tabs .tab {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--glass-border);\n  color: var(--text-secondary);\n  padding: 6px 12px;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.banner-type-tabs .tab.active {\n  background: var(--brand-primary);\n  border-color: var(--brand-primary);\n  color: white;\n}\n\n/* Profile Editor View */\n.profile-editor-view {\n  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.02));\n  border-radius: 18px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  min-height: 520px;\n  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.3);\n}\n\n.editor-header {\n  padding: 24px 32px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--glass-border);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.editor-header h2 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.editor-layout {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n.editor-controls {\n  flex: 1;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  overflow-y: auto;\n}\n\n/* Custom Scrollbar for Editor Controls */\n.editor-controls::-webkit-scrollbar {\n  width: 8px;\n}\n\n.editor-controls::-webkit-scrollbar-track {\n  background: var(--bg-secondary);\n}\n\n.editor-controls::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));\n  border-radius: 4px;\n}\n\n.editor-controls::-webkit-scrollbar-thumb:hover {\n  background: var(--brand-primary);\n}\n\n.editor-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.editor-section label {\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted);\n  letter-spacing: 0.1em;\n}\n\n.avatar-actions, .banner-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.action-btn {\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: all var(--transition-fast);\n}\n\n.action-btn.primary {\n  background: var(--brand-primary);\n  color: white;\n}\n\n.action-btn.secondary {\n  background: transparent;\n  border-color: var(--glass-border);\n  color: var(--text-primary);\n}\n\n.action-btn:hover {\n  filter: brightness(1.1);\n}\n\n.color-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.color-item {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid transparent;\n  transition: all var(--transition-fast);\n}\n\n.color-item:hover {\n  transform: scale(1.1);\n}\n\n.color-item.active {\n  border-color: white;\n}\n\n.editor-section textarea {\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-md);\n  padding: 12px;\n  color: var(--text-primary);\n  font-family: inherit;\n  font-size: 15px;\n  resize: none;\n  height: 100px;\n  outline: none;\n}\n\n.editor-input {\n  width: 100%;\n  background: rgba(15, 23, 42, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 10px 14px;\n  color: white;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.editor-input:focus {\n  border-color: var(--brand-primary);\n}\n\n.preview-username-tag {\n  font-size: 13px;\n  color: var(--text-muted);\n  margin-top: -4px;\n  margin-bottom: 12px;\n}\n\n.cropper-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, 0.9);\n  backdrop-filter: blur(10px);\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.cropper-card {\n  width: 100%;\n  max-width: 500px;\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.cropper-header {\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.cropper-header h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.cropper-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.cropper-container {\n  position: relative;\n  width: 100%;\n  height: 350px;\n  background: #000;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.cropper-controls {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 10px 5px;\n}\n\n.zoom-range {\n  flex: 1;\n  height: 4px;\n  background: var(--bg-modifier-hover);\n  border-radius: 2px;\n  appearance: none;\n  outline: none;\n}\n\n.zoom-range::-webkit-slider-thumb {\n  appearance: none;\n  width: 16px;\n  height: 16px;\n  background: white;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.cropper-footer {\n  padding: 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  background: rgba(0,0,0,0.2);\n}\n\n/* Ensure images cover their container */\n.preview-avatar img,\n.user-avatar img,\n.avatar-frame img,\n.avatar-main img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.char-count {\n  align-self: flex-end;\n  font-size: 12px;\n  color: var(--text-muted);\n}\n\n.editor-preview {\n  width: 360px;\n  padding: 32px;\n  background: rgba(0, 0, 0, 0.2);\n  border-left: 1px solid var(--glass-border);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  flex-shrink: 0;\n}\n\n.preview-card {\n  border-radius: 12px;\n  overflow: hidden;\n  background: var(--bg-secondary);\n  border: 1px solid var(--glass-border);\n  box-shadow: var(--shadow-xl);\n  width: 100%;\n}\n\n.preview-card .preview-banner {\n  height: 100px;\n}\n\n.preview-content {\n  padding: 16px;\n}\n\n.preview-avatar-wrapper {\n  margin-top: -45px;\n  margin-bottom: 12px;\n}\n\n.preview-avatar-wrapper .preview-avatar {\n  width: 70px;\n  height: 70px;\n  margin-top: 0;\n  border-width: 4px;\n}\n\n.preview-info h3 {\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.preview-info .tag {\n  color: var(--text-muted);\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.preview-bio {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n  margin-top: 8px;\n  white-space: pre-wrap;\n}\n\n.editor-footer {\n  padding: 16px 24px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  border-top: 1px solid var(--glass-border);\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.save-btn {\n  background: var(--brand-primary);\n  color: white;\n  border: none;\n  padding: 10px 24px;\n  border-radius: var(--radius-md);\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.cancel-btn {\n  background: transparent;\n  color: var(--text-secondary);\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.cancel-btn:hover {\n  color: var(--text-primary);\n}\n\n.field-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.bio-value {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 400px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: var(--radius-full);\n  transition: all var(--transition-fast);\n}\n\n.close-btn:hover {\n  background: var(--bg-modifier-hover);\n  color: var(--text-primary);\n}\n\n/* Connections */\n.connections-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 15px;\n}\n\n.connection-card {\n  background: #0f172a;\n  border-radius: 12px;\n  padding: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.connection-card.spotify {\n  border-left: 4px solid #1db954;\n}\n\n.conn-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.conn-status {\n  font-size: 11px;\n  font-weight: 800;\n  background: rgba(29, 185, 84, 0.2);\n  color: #1db954;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.conn-status.disconnected {\n  background: rgba(100, 116, 139, 0.2);\n  color: #64748b;\n}\n\n.conn-toggle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  font-size: 13px;\n}\n\n.toggle-switch {\n  width: 36px;\n  height: 20px;\n  background: #334155;\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n}\n\n.toggle-switch::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  background: white;\n  border-radius: 50%;\n  transition: 0.2s;\n}\n\n.toggle-switch.active {\n  background: #1db954;\n}\n\n.toggle-switch.active::after {\n  left: 18px;\n}\n\n/* Close Area */\n.settings-close-area {\n  position: absolute;\n  top: 24px;\n  right: 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  z-index: 20;\n}\n\n.close-circle-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.12));\n  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.05));\n  color: var(--text-secondary, #94a3b8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.close-circle-btn:hover {\n  background: rgba(239, 68, 68, 0.15);\n  border-color: rgba(239, 68, 68, 0.4);\n  color: #ef4444;\n  transform: rotate(90deg) scale(1.05);\n}\n\n.esc-text {\n  font-size: 10px;\n  font-weight: 800;\n  color: var(--text-muted, #64748b);\n  letter-spacing: 0.05em;\n}\n\n/* Theme Configuration Cards CSS */\n.themes-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 20px;\n  margin-top: 24px;\n}\n\n.theme-card {\n  background: var(--bg-primary);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  transition: all var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n}\n\n.theme-card:hover {\n  transform: translateY(-4px);\n  border-color: var(--brand-primary);\n  box-shadow: var(--shadow-md);\n}\n\n.theme-card.active {\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 12px rgba(153, 27, 27, 0.2);\n  background: var(--bg-modifier-selected);\n}\n\n/* Preview area inside card */\n.theme-card-preview {\n  height: 90px;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.color-strip {\n  position: absolute;\n  height: 12px;\n  width: 60px;\n  border-radius: 4px;\n}\n\n.brand-strip {\n  top: 24px;\n  left: 20px;\n}\n\n.text-strip {\n  top: 48px;\n  left: 20px;\n  width: 100px;\n}\n\n.theme-active-checkmark {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 24px;\n  height: 24px;\n  border-radius: var(--radius-full);\n  background: var(--brand-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-sm);\n}\n\n.theme-card-info {\n  padding: 16px;\n}\n\n.theme-card-info h4 {\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 6px;\n  color: var(--text-primary);\n}\n\n.theme-card-info p {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n/* Platform Connection Highlights */\n.connection-card.spotify { border-left: 4px solid #1db954; }\n.connection-card.steam { border-left: 4px solid #66c0f4; }\n.connection-card.epic { border-left: 4px solid #ffffff; }\n.connection-card.flexable { border-left: 4px solid #8b5cf6; }\n\n.conn-disconnect-btn {\n  background: transparent;\n  border: 1px solid #ef4444;\n  color: #ef4444;\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 15px;\n  transition: all var(--transition-fast);\n  text-align: center;\n}\n\n.conn-disconnect-btn:hover {\n  background: rgba(239, 68, 68, 0.1);\n  transform: translateY(-1px);\n}\n\n/* Modals */\n.connection-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, 0.8);\n  backdrop-filter: blur(12px);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.connection-modal {\n  width: 100%;\n  max-width: 440px;\n  padding: 24px;\n}\n\n/* Settings Blocks & Fields */\n.settings-block {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.settings-block h3 {\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--text-muted);\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.block-desc {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n/* Radio Cards (Privacy settings) */\n.radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.radio-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px;\n  background: rgba(255, 255, 255, 0.01);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.radio-card:hover {\n  background: var(--bg-modifier-hover);\n}\n\n.radio-card.active {\n  background: var(--bg-modifier-selected);\n  border-color: var(--brand-primary);\n}\n\n.radio-card input[type=\"radio\"] {\n  accent-color: var(--brand-primary);\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n  cursor: pointer;\n}\n\n.radio-label-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.radio-label-info strong {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.radio-label-info span {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n/* Checkbox inputs */\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 6px;\n}\n\n.checkbox-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  transition: color var(--transition-fast);\n}\n\n.checkbox-item:hover {\n  color: var(--text-primary);\n}\n\n.checkbox-item input[type=\"checkbox\"] {\n  accent-color: var(--brand-primary);\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* Block list styling */\n.blocklist-input-wrapper {\n  display: flex;\n  gap: 12px;\n  margin-top: 6px;\n}\n\n.block-input {\n  flex: 1;\n}\n\n.blocked-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-md);\n  padding: 12px;\n  background: rgba(0,0,0,0.1);\n}\n\n/* Custom Scrollbar for Blocked List */\n.blocked-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.blocked-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.blocked-list::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb, rgba(148, 163, 184, 0.2));\n  border-radius: 3px;\n}\n\n.blocked-list::-webkit-scrollbar-thumb:hover {\n  background: var(--brand-primary);\n}\n\n.blocked-user-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  border-radius: var(--radius-sm);\n  background: rgba(255,255,255,0.01);\n  border: 1px solid var(--glass-border);\n}\n\n.blocked-user-row span {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.unblock-btn {\n  background: none;\n  border: 1px solid var(--glass-border);\n  color: var(--text-secondary);\n  font-size: 12px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.unblock-btn:hover {\n  border-color: #ef4444;\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.no-blocked-users {\n  font-size: 13px;\n  color: var(--text-muted);\n  text-align: center;\n  padding: 20px 0;\n}\n\n/* Voice & Video inputs */\n.device-selects-row {\n  display: flex;\n  gap: 20px;\n  margin-top: 6px;\n}\n\n.select-field {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.select-field label {\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted);\n}\n\n.device-dropdown {\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  padding: 12px 14px;\n  font-size: 14px;\n  font-weight: 600;\n  outline: none;\n  cursor: pointer;\n  transition: border-color var(--transition-fast);\n}\n\n.device-dropdown:focus {\n  border-color: var(--brand-primary);\n}\n\n/* Range sliders (Voice level control) */\n.volume-sliders-group {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 6px;\n}\n\n.volume-slider-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.slider-labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  font-weight: 800;\n  color: var(--text-muted);\n}\n\n.voice-range-slider {\n  appearance: none;\n  width: 100%;\n  height: 6px;\n  border-radius: 3px;\n  background: var(--input-bg);\n  outline: none;\n}\n\n.voice-range-slider::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 6px;\n  cursor: pointer;\n}\n\n.voice-range-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: var(--radius-full);\n  background: white;\n  box-shadow: var(--shadow-sm);\n  cursor: pointer;\n  margin-top: -6px;\n  transition: all var(--transition-fast);\n}\n\n.voice-range-slider::-webkit-slider-thumb:hover {\n  background: var(--brand-light);\n  transform: scale(1.1);\n}\n\n/* Mic test visualization */\n.mic-test-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 8px;\n}\n\n.mic-test-btn.active-test {\n  background: var(--success);\n  box-shadow: 0 0 12px rgba(16, 185, 129, 0.3);\n}\n\n.mic-visualizer-track {\n  flex: 1;\n  height: 10px;\n  background: var(--input-bg);\n  border-radius: 5px;\n  overflow: hidden;\n  position: relative;\n  border: 1px solid var(--glass-border);\n}\n\n.mic-visualizer-bar {\n  height: 100%;\n  width: 0%;\n  border-radius: 5px;\n  transition: width 0.1s ease-out;\n}\n\n/* Toggle Switches */\n.toggle-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.toggle-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n}\n\n.toggle-label-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.toggle-label-info strong {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.toggle-label-info p {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n@media (max-width: 768px) {\n  .device-selects-row {\n    flex-direction: column;\n    gap: 12px;\n  }\n}\n\n/* Custom Select for Settings */\n.custom-select-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.custom-select-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  background-color: var(--input-bg, #1e1f22);\n  border: 1px solid var(--input-border, #1e1f22);\n  border-radius: 4px;\n  color: var(--text-primary, #dbdee1);\n  cursor: pointer;\n  transition: border-color 0.2s, background-color 0.2s;\n  font-size: 14px;\n}\n\n.custom-select-header:hover {\n  border-color: #000000;\n}\n\n.custom-select-header.open {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.custom-select-header-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-select-main-label {\n  font-weight: 500;\n}\n\n.custom-select-sub-label {\n  font-size: 12px;\n  color: var(--text-muted, #949ba4);\n  margin-top: 2px;\n}\n\n.custom-select-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background-color: var(--input-bg, #2b2d31);\n  border: 1px solid #1e1f22;\n  border-top: none;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  z-index: 100;\n  max-height: 250px;\n  overflow-y: auto;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.24);\n  padding: 4px 0;\n}\n\n.custom-select-menu::-webkit-scrollbar {\n  width: 8px;\n}\n.custom-select-menu::-webkit-scrollbar-thumb {\n  background: #1a1b1e;\n  border-radius: 4px;\n}\n\n.custom-select-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  margin: 0 4px;\n  border-radius: 3px;\n  cursor: pointer;\n  color: var(--text-primary, #dbdee1);\n  font-size: 14px;\n}\n\n.custom-select-item:hover {\n  background-color: rgba(79, 84, 92, 0.32);\n}\n\n.custom-select-item.selected {\n  background-color: rgba(79, 84, 92, 0.6);\n}\n\n.custom-select-item-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-select-check {\n  color: var(--brand-primary, #5865F2);\n  display: flex;\n  align-items: center;\n}\n\n/* ========================================================\n   DISCORD-STYLE SPOTIFY CONNECTED CARD (ACCURATE TO UI)\n   ======================================================== */\n.spotify-settings-block {\n  margin-top: 10px;\n}\n\n.settings-block-title {\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--text-muted, #64748b);\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n}\n\n.discord-connected-account-card {\n  background: #2b2d31;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 20px 24px;\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);\n  transition: all 0.2s ease;\n}\n\n.discord-connected-account-card:hover {\n  border-color: rgba(29, 185, 84, 0.3);\n}\n\n.dca-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dca-account-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dca-icon-circle.spotify {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(29, 185, 84, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #1db954;\n  flex-shrink: 0;\n}\n\n.dca-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.dca-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dca-name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.dca-premium-badge {\n  font-size: 9px;\n  font-weight: 800;\n  background: rgba(29, 185, 84, 0.2);\n  color: #1db954;\n  padding: 2px 6px;\n  border-radius: 4px;\n  letter-spacing: 0.05em;\n}\n\n.dca-platform {\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.dca-disconnect-btn {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.dca-disconnect-btn:hover {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.12);\n}\n\n.dca-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.06);\n  margin: 18px 0 14px 0;\n}\n\n.dca-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0;\n}\n\n.dca-toggle-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #f1f5f9;\n}\n\n/* Accurate iOS/Discord style toggle switch */\n.dca-toggle-switch {\n  width: 44px;\n  height: 24px;\n  background: #475569;\n  border-radius: 14px;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.dca-toggle-switch.active {\n  background: #5865f2 !important; /* Exact blue/purple matching screenshot */\n}\n\n.dca-toggle-slider {\n  width: 18px;\n  height: 18px;\n  background: #ffffff;\n  border-radius: 50%;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.dca-toggle-switch.active .dca-toggle-slider {\n  transform: translateX(20px);\n}\n\n/* Live Player Card inside Settings */\n.dca-live-player {\n  margin-top: 16px;\n  padding: 12px 14px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid rgba(29, 185, 84, 0.25);\n}\n\n.dca-live-art {\n  width: 46px;\n  height: 46px;\n  border-radius: 8px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.dca-live-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.dca-live-badge {\n  font-size: 10px;\n  font-weight: 800;\n  color: #1db954;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.live-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #1db954;\n  animation: pulse 1.5s infinite;\n}\n\n.dca-live-song {\n  font-size: 13px;\n  font-weight: 700;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dca-live-artist {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n/* Not connected banner */\n.spotify-connect-banner {\n  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.03));\n  border: 1px solid var(--glass-border, rgba(255, 255, 255, 0.08));\n  border-radius: 14px;\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.scb-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 260px;\n}\n\n.scb-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(29, 185, 84, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.scb-title {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.scb-desc {\n  margin: 0;\n  font-size: 12px;\n  color: var(--text-secondary, #94a3b8);\n  line-height: 1.4;\n  max-width: 440px;\n}\n\n.spotify-btn-action {\n  background: #1db954;\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  padding: 10px 20px;\n  font-weight: 700;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 14px rgba(29, 185, 84, 0.35);\n}\n\n.spotify-btn-action:hover {\n  background: #1ed760;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(29, 185, 84, 0.45);\n}\n\n.spotify-oauth-btn {\n  width: 100%;\n  background: #1db954;\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  padding: 12px;\n  font-weight: 700;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 14px rgba(29, 185, 84, 0.3);\n}\n\n.spotify-oauth-btn:hover {\n  background: #1ed760;\n  transform: translateY(-1px);\n}\n\n/* SoundCloud Connect Banner & Controls */\n.soundcloud-connect-banner {\n  background: var(--bg-modifier-hover, rgba(255, 255, 255, 0.03));\n  border: 1px solid rgba(255, 85, 0, 0.2);\n  border-radius: 14px;\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.scb-icon.soundcloud-icon {\n  background: rgba(255, 85, 0, 0.15);\n}\n\n.soundcloud-btn-action {\n  background: #ff5500;\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  padding: 10px 20px;\n  font-weight: 700;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 14px rgba(255, 85, 0, 0.35);\n}\n\n.soundcloud-btn-action:hover {\n  background: #ff6a1f;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(255, 85, 0, 0.45);\n}\n\n/* Connection Modal Styling */\n.connection-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n}\n\n.connection-modal.meci-modal {\n  background: #111827;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  width: 100%;\n  max-width: 440px;\n  padding: 28px 24px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7);\n  display: flex;\n  flex-direction: column;\n}\n\n.connection-modal .modal-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  text-align: left;\n}\n\n.connection-modal .modal-header h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.connection-modal .modal-header p {\n  font-size: 13px;\n  color: #94a3b8;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.connection-modal .editor-input {\n  background: #1e293b;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  padding: 12px 14px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.connection-modal .editor-input:focus {\n  border-color: #3b82f6;\n}\n\n.connection-modal .cancel-btn {\n  background: transparent;\n  color: #94a3b8;\n  border: none;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.connection-modal .cancel-btn:hover {\n  color: #ffffff;\n}\n\n.connection-modal .save-btn {\n  background: #10b981;\n  color: #ffffff;\n  border: none;\n  padding: 9px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.connection-modal .save-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Settings Camera Effects & Mirroring Controls ── */\n.camera-controls-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.camera-control-card {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  padding: 10px 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.camera-control-card:hover {\n  background: rgba(255, 255, 255, 0.07);\n  border-color: rgba(255, 255, 255, 0.18);\n  transform: translateY(-2px);\n}\n\n.camera-control-card.active {\n  background: rgba(88, 101, 242, 0.18);\n  border-color: #5865f2;\n  box-shadow: 0 0 14px rgba(88, 101, 242, 0.3);\n}\n\n.camera-control-card-icon {\n  font-size: 20px;\n  margin-bottom: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.camera-control-card-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #f1f5f9;\n}\n\n.camera-control-card-desc {\n  font-size: 10px;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
